import { createContext } from "react";

import { type CommonColors } from "../../../types/colors";

interface AccordionContext {
  defaultExpanded?: boolean;
  disabled: boolean;
  expanded: boolean;
  collapsible: boolean;
  variant?: CommonColors;
  toggle?: () => void;
}

export const Context = createContext<AccordionContext>({
  disabled: false,
  expanded: false,
  collapsible: true,
});
